import React from "react"
import TicketMiniBlue from "../../../../icons/TicketBlue"
import dayjs from "dayjs"
import Image from "next/image"
import { useLang } from "hooks/useLang"
import CustomImage from "components/atoms/Image/CustomImage"

interface IProps {
    title: string
    numberOfTickets: number
    status?: string
    poster: string
    event_id: string
    TransactionDate: string
    city: string
    onOpen: (e: any) => void
    isPast?: boolean
}

const TicketCard = (props: IProps) => {
    const {
        title,
        numberOfTickets,
        status,
        poster,
        TransactionDate,
        event_id,
        city,
        onOpen,
        isPast,
    } = props
    const { t } = useLang()

    return (
        <div
            className={`flex overflow-hidden rounded-md  text-sm shadow-3xl  md:text-base ${
                isPast ? "grayscale-[1]" : "grayscale-[0]"
            }`}
        >
            {/* Image cantainer */}
            <div className="relative h-full min-w-[150px] flex-[1]">
                <CustomImage
                    src={poster}
                    alt={`poster-${poster}`}
                    fill
                    style={{
                        filter: isPast ? "grayscale(1)" : "",
                        objectFit: "cover",
                    }}
                />
            </div>

            {/* info cantainer */}
            <div
                className="flex flex-[2] justify-between p-5 bg-white
dark:bg-white"
            >
                {/* Left side */}
                <div className="flex flex-col gap-4">
                    <h1 className="font-bold text-black capitalize">{title}</h1>
                    <div>
                        <div className="font-semibold text-black capitalize">
                            {t("date")}
                        </div>
                        <div className="text-sm text-black ">
                            {dayjs(TransactionDate).format("DD-MM-YYYY")}
                        </div>
                    </div>
                    <div>
                        <div className="font-semibold text-black capitalize">
                            {t("time")}
                        </div>
                        <div className="text-sm text-black">
                            {dayjs(TransactionDate).format("H:mm A")}
                        </div>
                    </div>
                    <div>
                        <div className="font-semibold text-black capitalize">
                            {t("location")}
                        </div>
                        <div className="text-sm text-black ">{t(city)}</div>
                    </div>
                </div>

                {/* Right side */}
                <div className="flex flex-col items-end justify-between">
                    <div className="flex items-center gap-2">
                        <TicketMiniBlue />
                        <span className="text-action-theme-400">
                            {numberOfTickets}
                        </span>
                    </div>

                    <div
                        onClick={onOpen}
                        className="font-semibold capitalize cursor-pointer w-fit text-action-theme-200 hover:underline"
                    >
                        {t("view")}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TicketCard
